import { render, staticRenderFns } from "./chat-gbs.vue?vue&type=template&id=40b8ddd0&"
import script from "./chat-gbs.vue?vue&type=script&lang=js&"
export * from "./chat-gbs.vue?vue&type=script&lang=js&"
import style0 from "./chat-gbs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QChatMessage from 'quasar/src/components/chat/QChatMessage.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QHeader,QToolbar,QBtn,QAvatar,QToolbarTitle,QFooter,QForm,QInput,QPageContainer,QPage,QBanner,QList,QItem,QItemSection,QItemLabel,QBadge,QChatMessage});qInstall(component, 'directives', {Ripple});
